import { createContext } from "react";
export const roleContext = createContext();
